export default "__VITE_ASSET__BGT11cKs__"